import React from 'react'
import { Outlet } from 'react-router-dom'

const ThemePage = () => {
  return (
    <Outlet />
  )
}

export default ThemePage